import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { userSchemaObject } from '../../Data';
import { Fields, validateProperty, validate, Card } from "../../Common";
import MessageModal from '../../../UI/Modal/MessageModal';
import { passwordSchemaObject } from '../../Data/Validation/passwordChangeSchema';
import { PageHeader } from '../../../Common';
import Joi from '@hapi/joi';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import tokenDecoder from '../../../Common/tokenDecoder'

export function UserPasswordChange(props) {
    const { data, edit } = props.location ?? props;
    const [pageProperties, setPageProperties] = useState({
        title: 'Add User',
        submitButtonName: 'Save',
        passwordFieldDisabled: false
    })
    const [roles, setRoles] = useState()
    const [groups, setGroups] = useState()
    const [entityType, setEntityType] = useState()
    const [errors, setErrors] = useState({})
    const [userPasswordChange, setUserPasswordChange] = useState({
        userName: "",
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""

    });
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })
    const [isOldPasswordHidden, setIsOldPasswordHidden] = useState(false);
    const [isBackHidden, setIsBackHidden] = useState(true);
    const [password, setPassword] = useState({});
    const [currentUserDetails, setCurrentUserDetails] = useState({});
    const schema = Joi.object(passwordSchemaObject).options({ allowUnknown: true })


    useEffect(() => {

        if (edit) {
            setPageProperties({
                title: 'Reset Password',
                submitButtonName: 'Reset Password'
            })
            setUserPasswordChange({
                ...userPasswordChange,
                userName: data.userName,
            })
            setIsOldPasswordHidden(true)

        } else {
            setPageProperties({
                title: 'Change Password',
                submitButtonName: 'Change Password'
            })
            setUserPasswordChange({
                ...userPasswordChange,
                userName: tokenDecoder.getUserNameFromToken()

            })
            setIsBackHidden(false)
        }
        setCurrentUserDetails(tokenDecoder.getUserDetailsFromToken());

    }, [])


    function handleChange(e) {
        const target = e.target

        const value = (target.name === 'isActive' || target.name === 'isLocked') ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, passwordSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setUserPasswordChange({
            ...userPasswordChange,
            [e.target.name]: value
        })
        setErrors(error)
    }




    async function handleSave(e) {
        e.preventDefault()
        const target = e.target

        if (userPasswordChange.newPassword == userPasswordChange.confirmPassword) {
            setPassword(userPasswordChange.confirmPassword);


            const errorMessages = validate(schema, userPasswordChange)
            errorMessages !== null ? setErrors(errorMessages) : setErrors({})
            let passwordFlag = false

            if (errorMessages != null) {
                var array = Object.keys(errorMessages);

                if (array.length === 1 && array.indexOf("oldPassword") === 0) {
                    passwordFlag = true;
                }
            }


            if (errorMessages && !passwordFlag && edit) {
                return
            }


            setErrors(errors)

            saveData();
        }
        else {
            setMessageModel({ ...messageModel, hidden: false, type: "Error", disciption: "Password mismatch" })
            setUserPasswordChange({
                ...userPasswordChange,
                confirmPassword: ""
            })
            setTimeout(() => {
                modalDismissHandler();
            }, 1500);
            return null;
        }
    }

    function logoutHandler() {
       // window.logout.logout();
       sessionStorage.removeItem('token');
       window.location.replace('/');
    }

    async function saveData() {
        if (edit) {
            const response = await services.resetUserV2(data, userPasswordChange.confirmPassword);
            if(response.statusCode = "Success"){
            }

            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });
            afterSuccessfulyReset(response.statusCode)
            
        }
        else {
            const response = await services.changePasswordV2(userPasswordChange);

            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });
            afterSuccessfulyChanged(response.statusCode)
             

        }
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                logoutHandler();
            }, 1500);
        }
        clearState()
    }

    function afterSuccessfulyReset(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/users' })
            }, 1500);
        }
        clearState();
        //window.logout = functionsWindow;
    }


    function clearState() {

        setUserPasswordChange({
            userName: "",
            oldPassword: "",
            newPassword: "",
            confirmPassword: ""
        })
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function setMessage(hidden, type, status) {
        setMessageModel({ ...messageModel, hidden: hidden, type: type, disciption: status })
    }

    function onCancelClick() {
        clearState();
        setErrors({});
    }
    function keyDown(e) {
        var e = window.event || e;
        var key = e.keyCode;
        if (key == 32) {
            e.preventDefault();
        }
    }

    return (
        <Fragment>
            <div className="row">
                <div className="col-md-12">

                    <div className="card">
                        <PageHeader
                            title={pageProperties.title}
                            isButtonEnable={isBackHidden}
                            buttonText="Back to Listing"
                            path="/users"
                        />


                        <form onSubmit={(e) => handleSave(e)}>
                            <div className="card-body">

                                <div className="form-group row">

                                    <div className="col-md">
                                        <InputLabel shrink id="userName">Username *</InputLabel>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            name="userName"
                                            id="userName"
                                            onChange={(e) => handleChange(e)}
                                            value={userPasswordChange.userName}
                                            maxLength={12}
                                            onKeyDown={(e) => keyDown(e)}
                                            disabled={edit}
                                        />
                                        {errors["userName"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["userName"]}</FormHelperText>}

                                    </div>



                                    <div className="col-md" hidden={isOldPasswordHidden}>
                                        <InputLabel shrink id="oldPassword">Old Password *</InputLabel>
                                        <TextField
                                            fullWidth
                                            type="password"
                                            name="oldPassword"
                                            id="oldPassword"
                                            onChange={(e) => handleChange(e)}
                                            value={userPasswordChange.oldPassword}
                                        />
                                        {errors["oldPassword"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["oldPassword"]}</FormHelperText>}

                                    </div>

                                    <div className="col-md">
                                        <InputLabel shrink id="newPassword">New Password *</InputLabel>
                                        <TextField
                                            fullWidth
                                            type="password"
                                            name="newPassword"
                                            id="newPassword"
                                            onChange={(e) => handleChange(e)}
                                            value={userPasswordChange.newPassword}
                                        />
                                        {errors["newPassword"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["newPassword"]}</FormHelperText>}

                                    </div>

                                    <div className="col-md">
                                        <InputLabel shrink id="confirmPassword">Confirm Password *</InputLabel>
                                        <TextField
                                            fullWidth
                                            type="password"
                                            name="confirmPassword"
                                            id="confirmPassword"
                                            onChange={(e) => handleChange(e)}
                                            value={userPasswordChange.confirmPassword}
                                        />
                                        {errors["confirmPassword"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["confirmPassword"]}</FormHelperText>}

                                    </div>


                                </div>


                            </div>

                            <MessageModal
                                hidden={messageModel.hidden}
                                messageType={messageModel.type}
                                messageDescription={messageModel.disciption}
                                clicked={modalDismissHandler}
                            />


                            <div className="card-footer">
                                <input
                                    type="submit"
                                    className="btn btn-primary"
                                    value={pageProperties.submitButtonName}
                                    onClick={handleSave}
                                />
                                <input
                                    type="reset"
                                    className="btn btn-warning pull-right"
                                    value="Clear"
                                    onClick={onCancelClick}
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}